<template>
  <TableBasicPreview :data="tableData" />
</template>

<script>
import TableBasicPreview from '@/components/table/BasicPreview.vue';

export default {
  name: 'SupplierDetails',
  components: {
    TableBasicPreview,
  },
  props: {
    supplier: {
      type: Object,
      required: true,
    },
  },
  computed: {
    tableData() {
      return ([
        {
          label: this.$t('contactDetailsPreviewLabelSupplier'),
          info: this.supplier.legal_name,
        },
        {
          label: this.$t('contactDetailsPreviewLabelCity'),
          info: this.supplier.city,
        },
        {
          label: this.$t('contactDetailsPreviewLabelZip'),
          info: this.supplier.zip,
        },
        {
          label: this.$t('contactDetailsPreviewLabelAddress'),
          info: this.supplier.address,
        },
        {
          label: this.$t('contactDetailsPreviewLabelPhone'),
          info: this.supplier.phone,
        },
        {
          label: this.$t('contactDetailsPreviewLabelFax'),
          info: this.supplier.fax,
        },
        {
          label: this.$t('contactDetailsPreviewLabelEmail'),
          info: this.supplier.email,
        },
        {
          label: this.$t('contactDetailsPreviewLabelWebsiteLink'),
          info: this.supplier.web,
          link: true,
        },
      ]);
    },
  },
};
</script>
